import script from "./updateEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./updateEmail.vue?vue&type=script&setup=true&lang=js"

import "./updateEmail.vue?vue&type=style&index=0&id=f9598efe&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9598efe"]])

export default __exports__